function matchesType(file, type) {
    if (type.startsWith('.')) {
        return file.name.toLowerCase().endsWith(type.toLowerCase());
    }
    if (type.endsWith('/*')) {
        return file.type.startsWith(type.slice(0, -1));
    }
    return file.type === type;
}
const fileTypeNameOverrides = {
    'image/*': 'Images',
};
function formatFileType(type) {
    if (fileTypeNameOverrides[type])
        return fileTypeNameOverrides[type];
    if (type.startsWith('.')) {
        return type.toUpperCase();
    }
    if (type.endsWith('/*')) {
        return type.replace('/*', '').toUpperCase();
    }
    return type;
}
function validateFile(file, accepted) {
    // No rules → accept everything
    if (!accepted || accepted.length === 0) {
        return [];
    }
    const matchingRules = accepted.filter((rule) => matchesType(file, rule.type));
    // No matching rule → type not allowed
    if (matchingRules.length === 0) {
        return ['File type not allowed'];
    }
    // Check size constraints
    for (const rule of matchingRules) {
        if (rule.maxSize && file.size > rule.maxSize) {
            return ['File is too large for this file type'];
        }
    }
    return [];
}

export { formatFileType, matchesType, validateFile };
//# sourceMappingURL=fileUploadHelpers.js.map
